// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"35":"fehler","177":"home"}[chunkId] || chunkId) + "." + {"35":"d54629c5","109":"3c1ebfd2","177":"c6210279","768":"4fee5eb2","859":"2441a109","861":"a86a5c0a","874":"a86a5c0a"}[chunkId] + ".css";
};